<div class="ml-2 flex h-16 flex-row space-x-5">
  <div
    tp="Turn off formula to activate control"
    [tpIsEnabled]="isDisabled === true"
  >
    <ng-select
      #fractionDayOfWeekIndexTypeSelect
      [fixNgSelectBottom]="fractionDayOfWeekIndexTypeSelect"
      data-cy="fractionDayOfWeekIndexTypeSelect"
      class="fraction-type-select w-[220px]"
      [items]="fractionDayOfWeekIndexTypesList"
      [clearable]="false"
      [searchable]="false"
      [disabled]="isDisabled === true"
      [(ngModel)]="fraction.type"
      (change)="typeChange($event)"
      (keyup.esc)="
        $event.stopImmediatePropagation();
        fractionDayOfWeekIndexTypeSelect.blur()
      "
      (keyup.enter)="
        $event.stopImmediatePropagation();
        fractionDayOfWeekIndexTypeSelect.blur()
      "
      appendTo="body"
      bindLabel="label"
      bindValue="value"
    >
      <ng-template ng-label-tmp let-item="item">
        <div class="ml-1 truncate">{{ item.label }}</div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div
          class="flex flex-row"
          [ngClass]="{
            'text-yellow-700': item.operator === fractionOperatorEnum.And
          }"
        >
          <div class="ml-1">{{ item.operator | uppercase }} -</div>
          <div class="ml-1 truncate">{{ item.label }}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <form
    [formGroup]="dayOfWeekIndexValuesForm"
    *ngIf="
      fraction.type === fractionTypeEnum.DayOfWeekIndexIsEqualTo ||
      fraction.type === fractionTypeEnum.DayOfWeekIndexIsNotEqualTo
    "
  >
    <div
      tp="Turn off formula to activate control"
      [tpIsEnabled]="isDisabled === true"
    >
      <fieldset [disabled]="isDisabled === true">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="fractionDayOfWeekIndexValuesInput"
          class="rows form-input border-s3 focus:border-m600 h-[36px] w-[250px] resize-none rounded"
          [ngClass]="{
            'border-r600':
              dayOfWeekIndexValuesForm.controls['dayOfWeekIndexValues']
                .invalid &&
              dayOfWeekIndexValuesForm.controls['dayOfWeekIndexValues'].touched
          }"
          formControlName="dayOfWeekIndexValues"
          (blur)="dayOfWeekIndexValuesBlur()"
        />
      </fieldset>
    </div>

    <m-validation
      [control]="dayOfWeekIndexValuesForm.controls['dayOfWeekIndexValues']"
    ></m-validation>
  </form>
</div>
